import { fetchTimelineEvents } from "./timelineApi";
import { useCallback, useEffect, useState } from "react";


export function useTimeline() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [query, setQuery] = useState("");
  const [category, setCategory] = useState(""); // "" | "activity" | "error"
  const [type, setType] = useState("");
  const [range, setRange] = useState("7d"); // "today" | "7d" | "30d" | "all"

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const data = await fetchTimelineEvents({ query, category, type, range });
      setEvents(data);
    } finally {
      setLoading(false);
    }
  }, [query, category, type, range]);

  useEffect(() => {
    const handle = setTimeout(load, 250);
    return () => clearTimeout(handle);
  }, [load]);

  return {
    events,
    loading,
    query,
    setQuery,
    category,
    setCategory,
    type,
    setType,
    range,
    setRange,
    refresh: load,
  };
}